export default "__VITE_ASSET__B8OVnM$a__"